import './seasons-view.css';

function statusLabel(status) {
  if (status === 'in_progress') return 'In Progress';
  if (status === 'completed') return 'Completed';
  if (status === 'scheduled') return 'Scheduled';
  if (status === 'final') return 'Final';
  return status;
}

export default function SeasonsView({ seasons, loading, error, onSelectSeason }) {
  return (
    <div className="app">
      {loading && <p className="loading">Loading seasons...</p>}
      {error && <p className="error">Error: {error}</p>}

      {!loading && !error && (
        <ul className="seasons-list">
          {seasons.map(season => (
            <li key={season.year} className="season-item" onClick={() => onSelectSeason(season)}>
              <span className="season-name">{season.name}</span>
              <span className={`season-status status-${season.status}`}>
                {statusLabel(season.status)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
